import { isEmpty } from '@intelligence/v3/utils/common';

const specialPageFiltersMap: IRecord<IRecord> = {
  'aiDailyNews/gameIndustry': {
    lowcode_template_type: 2,
    lowcode_template_key: 'ai_daily_news',
    page_log_key: 'aiDailyNews',
  },
  '/intelligence/aiDailyNews/AIIndustry': {
    lowcode_template_type: 1,
    lowcode_template_key: 'ai_industry_news',
    page_log_key: 'aiDailyNewsAIIndustry',
  },
  '/intelligence/casualGamesHub/IAABenchmarks': {
    lowcode_template_type: 1,
    lowcode_template_key: 'iaa_benchmarks',
    page_log_key: 'iaaBenchmarks',
  },
  '/intelligence/casualGamesHub/genreAnalysis': {
    title: 'Genre Analysis',
    pageTitle: '',
    gameCode: 'databrain',
    pageLogConfigKey: 'casualGamesGenreAnalysis',
  },
};

/**
 * 处理情报页面AI直达时filters的特殊处理逻辑
 * @param url 情报页面路由
 * @param filters 接口返回的filters
 * @return 处理后的url、filters
 */
export const buildFilters = (url: string, filters?: IRecord): { url: string; filters: IRecord } => {
  if (isEmpty(url)) {
    return { url: '', filters: {} };
  }

  const searchParamsIndex = url.indexOf('?');
  let newUrl = url;
  let newUrlParams: IRecord = {};

  if (searchParamsIndex !== -1) {
    newUrl = url.substring(0, searchParamsIndex);
    newUrlParams = (() => {
      const searchParams = new URLSearchParams(url.substring(searchParamsIndex + 1));
      const entries = searchParams.entries();
      const params: IRecord = {};
      for (const entry of entries) {
        const [key, value] = entry;
        params[key] = decodeURIComponent(value);
      }
      return params;
    })();
  }

  const specialFilters = specialPageFiltersMap[newUrl];

  return {
    url: newUrl,
    filters: { ...newUrlParams, ...filters, ...specialFilters },
  };
};
